import { ExpeditionBlockedReasonEnum } from "@/constants/enums/expeditionBlockedReason.enum";

export const EXPEDITION_BLOCKED_REASON_COLORS: Partial<
  Record<ExpeditionBlockedReasonEnum, string>
> = {
  [ExpeditionBlockedReasonEnum.RECIPIENT_ABSENT]: "#7B1FA2",
  [ExpeditionBlockedReasonEnum.LABEL_PRINTED_TIME_EXCEEDED]: "#B54708",
  [ExpeditionBlockedReasonEnum.LAST_SCAN_TIME_EXCEEDED]: "#B91C1C",
  [ExpeditionBlockedReasonEnum.CLEARANCE_SCAN_TIME_EXCEEDED]: "#067647",
  [ExpeditionBlockedReasonEnum.CUSTOMS_ISSUE]: "#DC2626",
  [ExpeditionBlockedReasonEnum.INCORRECT_ADDRESS]: "#3F51B5",
  [ExpeditionBlockedReasonEnum.PNC_ISSUE]: "#006D6F",
  [ExpeditionBlockedReasonEnum.PARTIAL_DELIVERY]: "#C2185B",
  [ExpeditionBlockedReasonEnum.TAX_NON_PAYMENT]: "#E64A19",
  [ExpeditionBlockedReasonEnum.CUSTOMS_CLEARANCE_IN_PROGRESS]: "#0277BD",
  [ExpeditionBlockedReasonEnum.RELAY_POINT]: "#424242",
  [ExpeditionBlockedReasonEnum.DAMAGED]: "#8B4513",
  [ExpeditionBlockedReasonEnum.RETURNED]: "#F57F17",
  [ExpeditionBlockedReasonEnum.LOST_PACKAGE]: "#616161",
  [ExpeditionBlockedReasonEnum.UNKNOWN]: "#E91E63",
  [ExpeditionBlockedReasonEnum.FEDEX]: "#4338CA",
  [ExpeditionBlockedReasonEnum.DELAY]: "#827717",
};
